import React, { useEffect, useState } from 'react';
import { Card, Col, Form, Row, Modal, Button, Badge, ProgressBar } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { useParams } from "react-router-dom";
import useToken from '../../../hooks/useToken';
import { useToast } from 'context/providers/ToastProvider';
import DatePicker from 'react-datepicker';
import IconButton from 'components/common/IconButton';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import { FiUser, FiCalendar, FiClock, FiWifi, FiArrowRight, FiUserCheck, FiRotateCcw, FiLink, FiSearch, FiDownload, FiTrash2, FiFileText, FiInfo, FiTag, FiMapPin, FiCheckCircle, FiXCircle, FiTool, FiDollarSign } from 'react-icons/fi';
import ImagenPerfil from '../../../components/common/ImagenPerfil';
import ModalVisualizarDetallesGasto from '../gastos/modal-registro-gasto/ModalVisualizarDetallesGasto';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';



const initialAssetState = {
    vNumeroRegistro: '',
    vNombreActivo: '',
    vDescripcion: '',
    idCategoria: 0,
    vNumeroSerie: '',
    vUbicacionActivo: '',
    dCostoAdquisicion: '',
    dFechaCompra: null,
    vImageName: '',
    dFechaUso: null,
    idEmpleadoResponsable: 0,
    iEstadoActivo: null,
    idGasto: null,
    dDepreciacionAnual: ''
};

const AssetForm = () => {

    const { token, setToken, idCatTipoUsuario } = useToken();
    const navigate = useNavigate();
    const { id } = useParams();
    const { showErrorToast, showSuccessToast } = useToast();


    const [cargando, setCargando] = useState(false);
    const [cargandoEmpleados, setCargandoEmpleados] = useState(false);
    const [empleados, setEmpleados] = useState([]);
    const [historialAsignaciones, setHistorialAsignaciones] = useState([]);
    const [responsableActual, setResponsableActual] = useState(0);


    const [asset, setAsset] = useState(initialAssetState);
    const [errores, setErrores] = useState({});
    const [editando, setEditando] = useState(id ? false : true);
    const [assetOriginal, setAssetOriginal] = useState(null);

    const [mostrarModalGasto, setMostrarModalGasto] = useState(false);
    const [showVistaGasto, setShowVistaGasto] = useState(false);
    const [searchTermGasto, setSearchTermGasto] = useState('');
    const [gastosEncontrados, setGastosEncontrados] = useState([]);
    const [buscandoGastos, setBuscandoGastos] = useState(false);
    const [descargandoNota, setDescargandoNota] = useState(false);

    /**
     * Búsqueda de gastos para vincular
     */
    const buscarGastos = async (termino) => {
        setBuscandoGastos(true);
        try {
            const response = await fetch("/api/ActivoFijo/BuscarGastosParaVincular", {
                method: 'POST',
                headers: {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ searchTerm: termino })
            });

            if (response.ok) {
                const data = await response.json();
                if (data.iResponseType === 1) {
                    const detalles = JSON.parse(data.detalles);
                    setGastosEncontrados(detalles.table2 || []);
                } else {
                    showErrorToast(data.vMessage);
                }
            } else {
                showErrorToast("Error al buscar gastos.");
            }
        } catch (error) {
            showErrorToast("Error en la petición de búsqueda.");
        } finally {
            setBuscandoGastos(false);
        }
    };

    // Debounce manual para la búsqueda
    useEffect(() => {
        if (!mostrarModalGasto) return;
        const delayDebounceFn = setTimeout(() => {
            buscarGastos(searchTermGasto);
        }, 300);

        return () => clearTimeout(delayDebounceFn);
    }, [searchTermGasto, mostrarModalGasto]);

    const handleSeleccionarGasto = (gasto) => {
        // Calcular valor unitario del activo: (Importe - Descuento) / Cantidad
        const importe = gasto.dGastoImporte != null ? parseFloat(gasto.dGastoImporte) : 0;
        const descuento = gasto.dGastoDescuento != null ? parseFloat(gasto.dGastoDescuento) : 0;
        const cantidad = gasto.dGastoCantidad != null ? parseFloat(gasto.dGastoCantidad) : 1;
        const valorCalculado = cantidad > 0 ? (importe - descuento) / cantidad : 0;

        setAsset(prev => ({
            ...prev,
            idGasto: gasto.idGasto,
            vNombreActivo: gasto.vGastoDescripcion ? gasto.vGastoDescripcion.toUpperCase() : '',
            dCostoAdquisicion: valorCalculado.toFixed(2),
            dFechaCompra: gasto.dFechaGasto ? new Date(gasto.dFechaGasto) : null,
            // Guardar detalles del gasto para la visualización de la tarjeta
            vGastoDescripcion: gasto.vGastoDescripcion,
            vGastoTipoGasto: gasto.vGastoTipoGasto,
            vGastoResponsable: gasto.vGastoResponsable,
            dFechaGasto: gasto.dFechaGasto,
            vGastoFormaPago: gasto.vGastoFormaPago,
            dGastoCantidad: gasto.dGastoCantidad,
            dGastoPrecioUnitario: gasto.dGastoPrecioUnitario,
            dGastoIva: gasto.dGastoIva,
            dGastoIvaRet: gasto.dGastoIvaRet,
            dGastoIsrRet: gasto.dGastoIsrRet,
            dGastoDescuento: gasto.dGastoDescuento,
            dGastoImporte: gasto.dGastoImporte,
            dGastoTotal: gasto.dGastoTotal,
            vGastoMoneda: gasto.vGastoMoneda,
            dGastoTipoCambio: gasto.dGastoTipoCambio,
            bHasNotaVenta: gasto.bHasNotaVenta,
            vGastoNotaVenta_Name: gasto.vGastoNotaVenta_Name,
            DetallesCuenta: gasto.DetallesCuenta,
            vRfcEmisor: gasto.vRfcEmisor,
            vRazonSocialEmisor: gasto.vRazonSocialEmisor,
            vUUIDFactura: gasto.vUUIDFactura,
            idFacturaRecibida: gasto.idFacturaRecibida
        }));

        setMostrarModalGasto(false);
        showSuccessToast("Gasto vinculado correctamente.");
    };

    const handleDesvincularGasto = () => {
        setAsset(prev => ({
            ...prev,
            idGasto: null,
            // Conservamos los valores autocompletados pero los campos ya no se bloquearán
            // y limpiamos los detalles de la tarjeta del gasto
            vGastoDescripcion: null,
            vGastoTipoGasto: null,
            vGastoResponsable: null,
            dFechaGasto: null,
            vGastoFormaPago: null,
            dGastoCantidad: null,
            dGastoPrecioUnitario: null,
            dGastoIva: null,
            dGastoIvaRet: null,
            dGastoIsrRet: null,
            dGastoDescuento: null,
            dGastoImporte: null,
            dGastoTotal: null,
            vGastoMoneda: null,
            dGastoTipoCambio: null,
            bHasNotaVenta: null,
            vGastoNotaVenta_Name: null,
            DetallesCuenta: null,
            vRfcEmisor: null,
            vRazonSocialEmisor: null,
            vUUIDFactura: null,
            idFacturaRecibida: null
        }));
        showSuccessToast("Gasto desvinculado correctamente.");
    };

    const handleDescargarNotaVenta = async (idGasto) => {
        setDescargandoNota(true);
        try {
            const response = await fetch(`/api/Gastos/ObtenerNotaVenta?idGasto=${idGasto}`, {
                method: 'GET',
                headers: {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json'
                },
            });

            if (response.ok) {
                const data = await response.json();

                if (data.iResponseType === 1) {
                    const detalles = JSON.parse(data.detalles);
                    const { vNotaVenta_Base64, vNotaVenta_Name } = detalles.table2[0];

                    const byteCharacters = atob(vNotaVenta_Base64);
                    const byteNumbers = new Array(byteCharacters.length);
                    for (let i = 0; i < byteCharacters.length; i++) {
                        byteNumbers[i] = byteCharacters.charCodeAt(i);
                    }
                    const byteArray = new Uint8Array(byteNumbers);
                    const blob = new Blob([byteArray], { type: 'application/octet-stream' });

                    const link = document.createElement('a');
                    link.href = URL.createObjectURL(blob);
                    link.download = vNotaVenta_Name;
                    document.body.appendChild(link);
                    link.click();
                    link.remove();
                    URL.revokeObjectURL(link.href);
                } else {
                    showErrorToast(data.vMessage || 'Error al obtener nota de venta');
                }
            } else {
                showErrorToast('Error en la petición: ' + response.statusText);
            }
        } catch (error) {
            showErrorToast('Error al descargar nota de venta');
            console.error('Error al descargar nota de venta:', error);
        } finally {
            setDescargandoNota(false);
        }
    };

    /**
     * Funcion para editar el activo fijo
     */
    const handleEditar = () => {
        setAssetOriginal(asset);
        setEditando(true);
    };

    /**
     * Funcion para cancelar la edición
     */
    const handleCancelar = () => {
        if (assetOriginal) setAsset(assetOriginal);
        setEditando(false);
    };



    /**
    * Funcion para obtener los activos fijos por ID
    */
    const obtenerActivoporID = async (idActivoFijo) => {

        console.log("idActivoFijo: ", idActivoFijo);

        setCargando(true);

        var dataToSend = {};
        dataToSend.idActivoFijo = idActivoFijo;
        setAsset(initialAssetState); // Usar estado inicial en vez de objeto vacío


        const response = await fetch("/api/ActivoFijo/ObtenerActivoFijoPorID",
            {
                method: 'POST',
                headers: {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(dataToSend)
            })
            .catch((error) => {
                showErrorToast('Hubo un problema con la peticion Fetch:' + error);
                //console.log('Hubo un problema con la peticion Fetch:' + error);

            });

        if (response.ok) {
            setCargando(false);
            //console.log("response: ", response);
            const data = await response.json();
            //console.log("data: ", data);


            if (data.iResponseType == 1) {

                var ObjDetalles = JSON.parse(data.detalles);
                console.log("data: ", ObjDetalles);

                setAsset(prev => ({
                    ...prev,
                    ...ObjDetalles.table2[0] // Sobrescribe solo los campos que llegan del servidor
                }));

                // Obtiene el responsable actua
                setResponsableActual(ObjDetalles.table2[0].idEmpleadoResponsable);
            } else {
                showErrorToast(data.vMessage);
            }

        }
        else {
            showErrorToast(response.status + ' ' + response.statusText);
            if (response.status == 401) {
                setToken(null);
                location.href = "";
            }
        }
    };




    /**
    * Funcion para el historial de asiganciones
    */
    const obtenerHistorialAsignaciones = async (idActivoFijo) => {
        setCargando(true);


        var dataToSend = {};
        dataToSend.idActivoFijo = idActivoFijo;


        const response = await fetch("/api/ActivoFijo/ObtenerHistorialAsignaciones",
            {
                method: 'POST',
                headers: {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(dataToSend)
            })
            .catch((error) => {
                showErrorToast('Hubo un problema con la peticion Fetch:' + error);
                //console.log('Hubo un problema con la peticion Fetch:' + error);

            });

        if (response.ok) {
            setCargando(false);
            //console.log("response: ", response);
            const data = await response.json();
            //console.log("data: ", data);


            if (data.iResponseType == 1) {
                var ObjDetalles = JSON.parse(data.detalles);

                console.log("ObjDetalles: historiual de asignaciones     ", ObjDetalles);

                setHistorialAsignaciones(ObjDetalles.table2 || []);


            } else {
                showErrorToast(data.vMessage);
            }

        }
        else {
            showErrorToast(response.status + ' ' + response.statusText);
            if (response.status == 401) {
                setToken(null);
                location.href = "";
            }
        }
    };

    /**
    * Funcion para manejar los cambios en el formulario
    */
    const handleChange = (e) => {
        const { name, value } = e.target;
        setAsset(prev => ({
            ...prev,
            [name]: value
        }));
    };

    /**
     * Funcion validar campos
     */
    const validarCampos = () => {
        const nuevosErrores = {};
        if (!asset.vNumeroRegistro) nuevosErrores.vNumeroRegistro = "El n\u00famero de registro es requerido";
        if (!asset.vNombreActivo) nuevosErrores.vNombreActivo = "El nombre del activo es requerido";
        if (!asset.vDescripcion) nuevosErrores.vDescripcion = "La descripci\u00f3n es requerida";
        if (!asset.dCostoAdquisicion) {
            nuevosErrores.dCostoAdquisicion = "El valor es requerido";
        } else if (Number(asset.dCostoAdquisicion) < 0) {
            nuevosErrores.dCostoAdquisicion = "El valor no puede ser negativo";
        }
        if (!asset.idCategoria) nuevosErrores.idCategoria = "La categor\u00eda es requerida";
        if (!asset.vNumeroSerie) nuevosErrores.vNumeroSerie = "El n\u00famero de serie es requerido";
        if (!asset.idEmpleadoResponsable) nuevosErrores.idEmpleadoResponsable = "El responsable es requerido";
        if (!asset.dFechaUso) nuevosErrores.dFechaUso = "La fecha de uso es requerida";
        if (!asset.dFechaCompra) nuevosErrores.dFechaCompra = "La fecha de compra es requerida";
        if (!asset.vUbicacionActivo) nuevosErrores.vUbicacionActivo = "La ubicaci\u00f3n es requerida";
        if (asset.iEstadoActivo === undefined || asset.iEstadoActivo === null) nuevosErrores.iEstadoActivo = "El estado es requerido";
        return nuevosErrores;
    };



    /**
     * Funcion para formulario
     */
    const handleSubmit = async (e) => {
        if (e) e.preventDefault();
        const nuevosErrores = validarCampos();
        setErrores(nuevosErrores);
        if (Object.keys(nuevosErrores).length > 0) {
            // Hay errores, no enviar
            return;
        }


        if (asset.idActivoFijo === 0 || asset.idActivoFijo === null || asset.idActivoFijo === undefined) {
            guardarActualizarActivoFijo(1);
        } else {
            guardarActualizarActivoFijo(2);
        }


    };

    /**
    * Funcion para guardar o actualizar los activos fijos
    */
    const guardarActualizarActivoFijo = async (action) => {

        setCargando(true);

        const dataToSend = {
            idActivoFijo: id && id !== "null" && id !== "undefined" ? id : 0,
            vNombreActivo: asset.vNombreActivo,
            vNumeroSerie: asset.vNumeroSerie,
            vNumeroRegistro: asset.vNumeroRegistro,
            idCategoria: asset.idCategoria,
            dFechaUso: asset.dFechaUso ? new Date(asset.dFechaUso).toISOString() : null,
            dFechaCompra: asset.dFechaCompra ? new Date(asset.dFechaCompra).toISOString() : null,
            dCostoAdquisicion: asset.dCostoAdquisicion ? Number(asset.dCostoAdquisicion) : null,
            vUbicacionActivo: asset.vUbicacionActivo,
            iEstadoActivo: asset.iEstadoActivo,
            idEmpleadoResponsable: asset.idEmpleadoResponsable,
            vImageName: asset.vImageName || "default.jpg",
            vDescripcion: asset.vDescripcion || "Sin descripción",
            idResponsableActual: responsableActual,
            idGasto: asset.idGasto ? Number(asset.idGasto) : null,
            dDepreciacionAnual: asset.dDepreciacionAnual ? Number(asset.dDepreciacionAnual) : null
        };
        console.log("Enviando datos:", action);

        setAsset(initialAssetState);
        const response = await fetch("/api/ActivoFijo/GuardarActualizarActivoFijo",
            {
                method: 'POST',
                headers: {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(dataToSend)
            })
            .catch((error) => {
                showErrorToast('Hubo un problema con la peticion Fetch:' + error);
                //console.log('Hubo un problema con la peticion Fetch:' + error);

            });

        if (response.ok) {
            //console.log("response: ", response);
            const data = await response.json();
            //console.log("data: ", data);


            if (data.iResponseType == 1) {
                console.log("Enviando datos:", action);

                if (action === 1) {
                    showSuccessToast("Activo fijo registrado correctamente");
                    navigate("/administracion/activo-fijo/");
                } else {
                    setCargando(false);


                    obtenerActivoporID(id);
                    obtenerHistorialAsignaciones(id);
                    setEditando(false);
                    showSuccessToast("Activo fijo actualizado correctamente");
                }

            } else {
                showErrorToast(data.vMessage);
                setCargando(false);
                setEditando(false);

            }

        }
        else {
            showErrorToast(response.status + ' ' + response.statusText);
            if (response.status == 401) {
                setToken(null);
                location.href = "";
                setCargando(false);
                setEditando(false);
            }
        }

    };

    /**
     * Funcion para obtener los empleados
     */
    const obtenerListaEmpleados = async () => {
        setCargandoEmpleados(true);
        const response = await fetch("/api/ActivoFijo/ObtenerEmpleados",
            {
                method: 'GET',
                headers: {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json'
                }
            })
            .catch((error) => {
                showErrorToast('Hubo un problema con la peticion Fetch:' + error);
                //console.log('Hubo un problema con la peticion Fetch:' + error);

            });

        if (response && response.ok) {
            setCargandoEmpleados(false);
            //console.log("response: ", response);
            const data = await response.json();
            //console.log("data: ", data);


            if (data.iResponseType == 1) {
                var ObjDetalles = JSON.parse(data.detalles);

                console.log("ObjDetalles: ", ObjDetalles);

                setEmpleados(ObjDetalles.table2);



            } else {
                showErrorToast(data.vMessage);
                setCargandoEmpleados(false);
            }

        }
        else {
            showErrorToast(response.status + ' ' + response.statusText);
            if (response.status == 401) {
                setToken(null);
                location.href = "";
                setCargandoEmpleados(false);
            }
        }
    };

    /**
    * Verifica los permisos
    */
    const checkPermisos = async () => {

        const response = await fetch("/api/Administradores/checkPermisos",
            {
                method: 'POST',
                headers:
                {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json'
                }
            }).catch((error) => {
                showErrorToast('Hubo un problema con la peticion Fetch:' + error);

                console.log('Hubo un problema con la peticion Fetch:' + error);
            });

        if (response.ok) {
            const responseType = await response.json();
            console.log(responseType);

            if (responseType.iResponseType == 1) {

                //ok


            } else {
                navigate("/");
            }

        }
        else {
            navigate("/");
        }
    }


    /**
    * Se ejecuta al cargar el componente
    */
    useEffect(() => {

        if (idCatTipoUsuario != 1) {
            navigate("/");
        }

        checkPermisos();
        obtenerListaEmpleados();
        if (id) {
            obtenerActivoporID(id);
            obtenerHistorialAsignaciones(id);
        }

    }, []);

    const calcularTiempoUso = (fechaUso) => {
        if (!fechaUso) return '-';
        const inicio = new Date(fechaUso);
        const hoy = new Date();
        if (inicio > hoy) return 'Aún no en uso';

        let years = hoy.getFullYear() - inicio.getFullYear();
        let months = hoy.getMonth() - inicio.getMonth();

        if (months < 0) {
            years--;
            months += 12;
        }

        if (years === 0 && months === 0) return 'Menos de un mes';

        let res = [];
        if (years > 0) res.push(`${years} ${years === 1 ? 'año' : 'años'}`);
        if (months > 0) res.push(`${months} ${months === 1 ? 'mes' : 'meses'}`);

        return res.join(', ');
    };

    return (
        <>


            <Card className="mb-3 shadow-sm">
                <Card.Body>
                    <Row className="align-items-center">
                        {/* Botón regresar */}
                        <Col xs="auto">
                            <IconButton
                                onClick={() => navigate(-1)}
                                variant="falcon-default"
                                size="sm"
                                icon="arrow-left"
                            />
                        </Col>

                        {/* Título */}
                        <Col className="flex-grow-1">
                            <h4 className="mb-0 text-nowrap ms-2">
                                {
                                    <>
                                        <span className="d-none d-sm-inline ms-1">
                                            {id ? "Actualizaci\u00F3n de Activo Fijo" : "Registro de Nuevo Activo Fijo"}
                                        </span>
                                        <span className="d-inline d-sm-none ms-1">
                                            {id ? "Actualizaci\u00F3n" : "Registro"}
                                        </span>
                                    </>
                                }
                            </h4>
                        </Col>

                        {/* Botones de acción - derecha */}
                        <Col xs="auto" className="text-end">
                            {!editando ? (
                                <IconButton
                                    onClick={handleEditar}
                                    variant="falcon-primary"
                                    size="sm"
                                    icon="pencil-alt"
                                    transform="shrink-2"
                                >
                                    <span className="d-none d-xl-inline-block ms-1">Editar detalles</span>
                                </IconButton>
                            ) : (
                                <>
                                    <IconButton
                                        variant="falcon-success"
                                        size="sm"
                                        icon="check"
                                        type="submit"
                                        disabled={cargando}
                                        className="me-2 mt-3-xs"
                                        onClick={handleSubmit}
                                    >
                                        {cargando ? (
                                            <span className="d-none d-xl-inline-block ms-1">Guardando...</span>
                                        ) : (
                                            <span className="d-none d-xl-inline-block ms-1">Guardar</span>
                                        )}
                                    </IconButton>
                                    {id && (
                                        <IconButton
                                            variant="falcon-secondary"
                                            size="sm"
                                            icon="times"
                                            type="button"
                                            onClick={handleCancelar}
                                            disabled={cargando}
                                            className="mt-3-xs"
                                        >
                                            <span className="d-none d-xl-inline-block ms-1">Cancelar</span>
                                        </IconButton>
                                    )}
                                </>
                            )}
                        </Col>
                    </Row>
                </Card.Body>
            </Card>

            {/* FORMULARIO CON MATERIAL UI: ESTRUCTURA PERSONALIZADA Y TODOS LOS CAMPOS */}
            {
                cargando || cargandoEmpleados ? (
                    <Card className="shadow-sm mb-3">
                        <Card.Body>
                            {/* Simulación de tabla con Skeleton */}
                            <Skeleton height={24} width={180} style={{ marginBottom: 12 }} /> {/* Cabecera */}
                            {[...Array(5)].map((_, i) => (
                                <Skeleton key={i} height={40} style={{ marginBottom: 16, borderRadius: 6 }} />
                            ))}
                        </Card.Body>
                    </Card>
                ) : (
                    <>
                        {!editando && id ? (
                            <div className="mb-4">
                                {/* Fila 1 */}
                                <Row className="mb-3 g-3">
                                    <Col xs={12} md={8}>
                                        {(() => {
                                            let iconBgClass = 'bg-success';
                                            let iconComponent = <FiCheckCircle className="text-white fs-4" />;
                                            let estadoTitle = 'Óptimo';
                                            let estadoDesc = 'El activo cumple con todos los protocolos vigentes.';
                                            let textHeaderColor = 'text-success';

                                            if (asset.iEstadoActivo == 1) {
                                                iconBgClass = 'bg-success';
                                                iconComponent = <FiCheckCircle className="text-white fs-4" />;
                                                estadoTitle = 'Activo';
                                                estadoDesc = 'El activo cumple con todos los protocolos vigentes.';
                                                textHeaderColor = 'text-success';
                                            } else if (asset.iEstadoActivo == 0) {
                                                iconBgClass = 'bg-danger';
                                                iconComponent = <FiXCircle className="text-white fs-4" />;
                                                estadoTitle = 'Inservible';
                                                estadoDesc = 'El activo ha sido dado de baja o es inservible.';
                                                textHeaderColor = 'text-danger';
                                            } else if (asset.iEstadoActivo == 2) {
                                                iconBgClass = 'bg-warning';
                                                iconComponent = <FiTool className="text-white fs-4" />;
                                                estadoTitle = 'En Reparación';
                                                estadoDesc = 'El activo se encuentra actualmente en mantenimiento.';
                                                textHeaderColor = 'text-warning';
                                            }

                                            let depreciacionAcumulada = 0;
                                            let saludColor = 'success';
                                            if (asset.dFechaCompra && asset.dDepreciacionAnual) {
                                                const inicio = new Date(asset.dFechaCompra);
                                                const hoy = new Date();
                                                if (hoy > inicio) {
                                                    const diffTime = Math.abs(hoy - inicio);
                                                    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
                                                    const diffYears = diffDays / 365.25;

                                                    depreciacionAcumulada = diffYears * asset.dDepreciacionAnual;
                                                    if (depreciacionAcumulada > 100) {
                                                        depreciacionAcumulada = 100;
                                                    }
                                                }
                                            }

                                            let saludRestante = 100 - depreciacionAcumulada;

                                            if (saludRestante <= 0) {
                                                saludColor = 'dark';
                                            } else if (saludRestante <= 25) {
                                                saludColor = 'danger';
                                            } else if (saludRestante <= 50) {
                                                saludColor = 'warning';
                                            } else if (saludRestante <= 75) {
                                                saludColor = 'info';
                                            } else {
                                                saludColor = 'success';
                                            }

                                            return (
                                                <Card className="border-0 shadow-sm rounded-4 h-100">
                                                    <Card.Body className="p-4 d-flex align-items-center">
                                                        <Row className="w-100 align-items-center g-0">
                                                            {/* Izquierda: Icono y Texto */}
                                                            <Col xs={12} lg={7} className="d-flex align-items-center mb-3 mb-lg-0">
                                                                <div className={`${iconBgClass} rounded-3 d-flex justify-content-center align-items-center shadow-sm me-3`} style={{ width: '48px', height: '48px', flexShrink: 0 }}>
                                                                    {iconComponent}
                                                                </div>
                                                                <div>
                                                                    <h6 className={`fw-bold mb-1 ${textHeaderColor}`} style={{ fontSize: '1rem' }}>
                                                                        Estado Operativo: {estadoTitle}
                                                                    </h6>
                                                                    <p className="text-muted mb-0" style={{ fontSize: '0.75rem', lineHeight: '1.2' }}>
                                                                        {estadoDesc}
                                                                    </p>
                                                                </div>
                                                            </Col>

                                                            {/* Derecha: Barra de Salud */}
                                                            <Col xs={12} lg={5} className="d-flex flex-column justify-content-center align-items-lg-end">
                                                                {asset.dDepreciacionAnual > 0 && asset.dFechaCompra && (
                                                                    <div className="w-100" style={{ maxWidth: '200px', marginLeft: 'auto' }}>
                                                                        <div className="text-uppercase text-muted fw-bold mb-1 text-end" style={{ fontSize: '0.60rem', letterSpacing: '0.5px' }}>
                                                                            Salud del Activo
                                                                        </div>
                                                                        <div className="d-flex align-items-center justify-content-end">
                                                                            <ProgressBar
                                                                                now={saludRestante}
                                                                                variant={saludColor}
                                                                                style={{ height: '8px', flexGrow: 1 }}
                                                                                className="shadow-sm me-2 bg-white"
                                                                            />
                                                                            <span className={`fw-bold text-${saludColor}`} style={{ fontSize: '0.9rem', minWidth: '40px', textAlign: 'right' }}>
                                                                                {saludRestante <= 0 ? '0%' : `${saludRestante.toFixed(0)}%`}
                                                                            </span>
                                                                        </div>
                                                                    </div>
                                                                )}
                                                            </Col>
                                                        </Row>
                                                    </Card.Body>
                                                </Card>
                                            );
                                        })()}
                                    </Col>
                                    <Col xs={12} md={4}>
                                        <Card className="border-0 shadow-sm rounded-4 h-100">
                                            <Card.Body className="p-4 d-flex flex-column justify-content-center align-items-start text-start">
                                                <div className="d-flex align-items-center mb-3">
                                                    <div className="bg-soft-success rounded-circle d-flex justify-content-center align-items-center me-2" style={{ width: '28px', height: '28px' }}>
                                                        <FiDollarSign className="text-success" />
                                                    </div>
                                                    <h6 className="mb-0 fw-bold text-dark text-uppercase" style={{ fontSize: '0.85rem' }}>Valor</h6>
                                                </div>
                                                <div className="text-dark fw-bold d-flex align-items-baseline flex-wrap" style={{ fontSize: 'clamp(1.8rem, 2.5vw, 2.5rem)', lineHeight: '1.2' }}>
                                                    <span className="text-break">
                                                        {new Intl.NumberFormat('es-MX', {
                                                            style: 'currency',
                                                            currency: asset.vGastoMoneda || 'MXN'
                                                        }).format(asset.dCostoAdquisicion || 0)}
                                                    </span>
                                                    <span className="ms-1 text-muted fw-semibold" style={{ fontSize: '1rem' }}>
                                                        {asset.vGastoMoneda || 'MXN'}
                                                    </span>
                                                </div>
                                            </Card.Body>
                                        </Card>
                                    </Col>
                                </Row>

                                {/* Fila 2 */}
                                <Row className="mb-3 g-3">
                                    <Col xs={12} md={4}>
                                        <Card className="border-0 shadow-sm rounded-4 h-100">
                                            <Card.Body className="p-4">
                                                <div className="d-flex align-items-center mb-3">
                                                    <div className="bg-soft-primary rounded-circle d-flex justify-content-center align-items-center me-2" style={{ width: '28px', height: '28px' }}>
                                                        <FiInfo className="text-primary" />
                                                    </div>
                                                    <h6 className="mb-0 fw-bold text-dark">IDENTIFICACIÓN</h6>
                                                </div>
                                                <div className="mb-3">
                                                    <div className="text-uppercase text-muted fw-semibold mb-1" style={{ fontSize: '0.65rem', letterSpacing: '0.5px' }}>Nombre del Activo</div>
                                                    <div className="text-dark fw-bold">{asset.vNombreActivo}</div>
                                                </div>
                                                <Row className="mb-3">
                                                    <Col xs={12} xl={6} className="mb-3 mb-xl-0">
                                                        <div className="text-uppercase text-muted fw-semibold mb-1" style={{ fontSize: '0.65rem', letterSpacing: '0.5px' }}>N&uacute;mero de serie</div>
                                                        <div className="text-dark fw-bold">{asset.vNumeroSerie}</div>
                                                    </Col>
                                                    <Col xs={12} xl={6}>
                                                        <div className="text-uppercase text-muted fw-semibold mb-1" style={{ fontSize: '0.65rem', letterSpacing: '0.5px' }}>N&uacute;mero de registro</div>
                                                        <div className="text-dark fw-bold">{asset.vNumeroRegistro}</div>
                                                    </Col>
                                                </Row>
                                                <div>
                                                    <div className="text-uppercase text-muted fw-semibold mb-1" style={{ fontSize: '0.65rem', letterSpacing: '0.5px' }}>Descripci&oacute;n</div>
                                                    <div className="text-dark fw-bold">{asset.vDescripcion}</div>
                                                </div>
                                            </Card.Body>
                                        </Card>
                                    </Col>
                                    <Col xs={12} md={4}>
                                        <Card className="border-0 shadow-sm rounded-4 h-100">
                                            <Card.Body className="p-4">
                                                <div className="d-flex align-items-center mb-3">
                                                    <div className="bg-soft-info rounded-circle d-flex justify-content-center align-items-center me-2" style={{ width: '28px', height: '28px' }}>
                                                        <FiTag className="text-info" />
                                                    </div>
                                                    <h6 className="mb-0 fw-bold text-dark">CLASIFICACIÓN</h6>
                                                </div>
                                                <div className="mb-3">
                                                    <div className="text-uppercase text-muted fw-semibold mb-1" style={{ fontSize: '0.65rem', letterSpacing: '0.5px' }}>CATEGOR&Iacute;A</div>
                                                    <div className="text-dark fw-bold">{asset.idCategoria === 1 ? 'Electrónica' : asset.idCategoria}</div>
                                                </div>

                                                <div className="mb-3">
                                                    <div className="text-uppercase text-muted fw-semibold mb-1" style={{ fontSize: '0.65rem', letterSpacing: '0.5px' }}>ESTADO DEL ACTIVO</div>
                                                    <div>
                                                        {asset.iEstadoActivo === 0 && (
                                                            <div className="d-inline-flex align-items-center justify-content-center bg-soft-danger text-danger fw-bold rounded-pill px-3 py-1 text-center" style={{ fontSize: '0.7rem', letterSpacing: '0.5px', lineHeight: '1.2' }}>
                                                                <span className="bg-danger rounded-circle me-2 flex-shrink-0" style={{ width: '6px', height: '6px' }}></span>
                                                                INSERVIBLE
                                                            </div>
                                                        )}
                                                        {asset.iEstadoActivo === 1 && (
                                                            <div className="d-inline-flex align-items-center justify-content-center bg-soft-success text-success fw-bold rounded-pill px-3 py-1 text-center" style={{ fontSize: '0.7rem', letterSpacing: '0.5px', lineHeight: '1.2' }}>
                                                                <span className="bg-success rounded-circle me-2 flex-shrink-0" style={{ width: '6px', height: '6px' }}></span>
                                                                ACTIVO - OPERATIVO
                                                            </div>
                                                        )}
                                                        {asset.iEstadoActivo === 2 && (
                                                            <div className="d-inline-flex align-items-center justify-content-center bg-soft-warning text-warning fw-bold rounded-pill px-3 py-1 text-center" style={{ fontSize: '0.7rem', letterSpacing: '0.5px', lineHeight: '1.2' }}>
                                                                <span className="bg-warning rounded-circle me-2 flex-shrink-0" style={{ width: '6px', height: '6px' }}></span>
                                                                EN REPARACIÓN
                                                            </div>
                                                        )}
                                                        {(asset.iEstadoActivo !== 0 && asset.iEstadoActivo !== 1 && asset.iEstadoActivo !== 2) && <div className="text-dark fw-bold">-</div>}
                                                    </div>
                                                </div>

                                                <div>
                                                    <div className="text-uppercase text-muted fw-semibold mb-1" style={{ fontSize: '0.65rem', letterSpacing: '0.5px' }}>DEPRECIACIÓN</div>
                                                    <div className="text-primary fw-bold">{asset.dDepreciacionAnual ? `${asset.dDepreciacionAnual}% anual` : '-'}</div>
                                                </div>
                                            </Card.Body>
                                        </Card>
                                    </Col>
                                    <Col xs={12} md={4}>
                                        <Card className="border-0 shadow-sm rounded-4 h-100">
                                            <Card.Body className="p-4">
                                                <div className="d-flex align-items-center mb-3">
                                                    <div className="bg-soft-warning rounded-circle d-flex justify-content-center align-items-center me-2" style={{ width: '28px', height: '28px' }}>
                                                        <FiMapPin className="text-warning" />
                                                    </div>
                                                    <h6 className="mb-0 fw-bold text-dark">LOGÍSTICA</h6>
                                                </div>
                                                <div className="mb-3">
                                                    <div className="text-uppercase text-muted fw-semibold mb-1" style={{ fontSize: '0.65rem', letterSpacing: '0.5px' }}>RESPONSABLE ASIGNADO</div>
                                                    <div className="d-flex align-items-center">
                                                        <div className="me-3" style={{ transform: 'scale(0.8)', transformOrigin: 'left center' }}>
                                                            <ImagenPerfil idUsuario={asset.idEmpleadoResponsable} />
                                                        </div>
                                                        <div>
                                                            <div className="text-dark fw-bold" style={{ lineHeight: '1.2' }}>
                                                                {empleados.find(e => e.idUsuario === asset.idEmpleadoResponsable)?.vNombre || asset.idEmpleadoResponsable} {empleados.find(e => e.idUsuario === asset.idEmpleadoResponsable)?.vApellidos || ''}
                                                            </div>
                                                            <div className="text-muted" style={{ fontSize: '0.75rem' }}>
                                                                {empleados.find(e => e.idUsuario === asset.idEmpleadoResponsable)?.vNombreTipoUsuario || 'Rol no especificado'}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div>
                                                    <div className="text-uppercase text-muted fw-semibold mb-1" style={{ fontSize: '0.65rem', letterSpacing: '0.5px' }}>UBICACI&Oacute;N ACTUAL</div>
                                                    <div className="text-dark fw-bold d-flex align-items-center">
                                                        <FiMapPin className="text-muted me-1" style={{ fontSize: '0.8rem' }} />
                                                        {asset.vUbicacionActivo}
                                                    </div>
                                                </div>
                                            </Card.Body>
                                        </Card>
                                    </Col>
                                </Row>

                                {/* Gasto Vinculado */}
                                {asset.idGasto ? (
                                    <Row className="mb-3 g-3">
                                        <Col xs={12}>
                                            <Card className="border-0 shadow-sm rounded-4">
                                                <Card.Body className="p-4">
                                                    <div className="d-flex align-items-center mb-3">
                                                        <div className="bg-primary rounded-circle d-flex justify-content-center align-items-center me-3 shadow-sm" style={{ width: '42px', height: '42px' }}>
                                                            <FiLink className="text-white fs-5" />
                                                        </div>
                                                        <div>
                                                            <h6 className="mb-1 fw-bold text-dark d-flex align-items-center" style={{ fontSize: '1rem' }}>
                                                                Gasto Vinculado:
                                                                <Button
                                                                    variant="link"
                                                                    className="p-0 ms-1 fw-bold text-primary text-decoration-none"
                                                                    style={{ fontSize: '1rem' }}
                                                                    onClick={() => setShowVistaGasto(true)}
                                                                >
                                                                    #{asset.idGasto}
                                                                </Button>
                                                            </h6>
                                                            <div className="text-muted" style={{ fontSize: '0.8rem' }}>Detalles del pago original asociado a este activo.</div>
                                                        </div>
                                                    </div>
                                                    {asset.vGastoDescripcion ? (
                                                        <Row className="rounded-3 p-3 mx-0 border" style={{ opacity: 0.95 }}>
                                                            <Col xs={12} md={8} className="border-end-md pe-md-4">
                                                                <Row>
                                                                    <Col xs={12} className="mb-3">
                                                                        <div className="text-uppercase text-muted fw-semibold mb-1" style={{ fontSize: '0.65rem', letterSpacing: '0.5px' }}>Concepto Original</div>
                                                                        <div className="fw-bold text-dark" style={{ fontSize: '0.85rem' }}>{asset.vGastoDescripcion}</div>
                                                                    </Col>
                                                                    <Col xs={12} md={6} className="mb-3">
                                                                        <div className="text-uppercase text-muted fw-semibold mb-1" style={{ fontSize: '0.65rem', letterSpacing: '0.5px' }}>Categoría</div>
                                                                        <div className="fw-bold text-dark" style={{ fontSize: '0.85rem' }}>{asset.vGastoTipoGasto || '-'}</div>
                                                                    </Col>
                                                                    <Col xs={12} md={6} className="mb-3">
                                                                        <div className="text-uppercase text-muted fw-semibold mb-1" style={{ fontSize: '0.65rem', letterSpacing: '0.5px' }}>Forma de Pago</div>
                                                                        <div className="fw-bold text-dark" style={{ fontSize: '0.85rem' }}>{asset.vGastoFormaPago || '-'}</div>
                                                                    </Col>
                                                                    <Col xs={12} md={6} className="mb-3">
                                                                        <div className="text-uppercase text-muted fw-semibold mb-1" style={{ fontSize: '0.65rem', letterSpacing: '0.5px' }}>Fecha del Gasto</div>
                                                                        <div className="fw-bold text-dark" style={{ fontSize: '0.85rem' }}>
                                                                            {asset.dFechaGasto ? new Date(asset.dFechaGasto).toLocaleDateString("es-MX", { day: '2-digit', month: 'short', year: 'numeric' }) : '-'}
                                                                        </div>
                                                                    </Col>
                                                                    <Col xs={12} md={6} className="mb-3">
                                                                        <div className="text-uppercase text-muted fw-semibold mb-1" style={{ fontSize: '0.65rem', letterSpacing: '0.5px' }}>Cuenta</div>
                                                                        <div className="fw-bold text-dark" style={{ fontSize: '0.85rem' }}>
                                                                            {asset.DetallesCuenta ? <Badge bg="light" text="dark" className="border">{asset.DetallesCuenta}</Badge> : '-'}
                                                                        </div>
                                                                    </Col>
                                                                    <Col xs={12} md={6} className="mb-3 mb-md-0">
                                                                        <div className="text-uppercase text-muted fw-semibold mb-1" style={{ fontSize: '0.65rem', letterSpacing: '0.5px' }}>Emisor</div>
                                                                        <div className="fw-bold text-dark" style={{ fontSize: '0.85rem' }}>
                                                                            {(asset.vRfcEmisor || asset.vRazonSocialEmisor) ? `${asset.vRfcEmisor || ''}${asset.vRfcEmisor && asset.vRazonSocialEmisor ? ' - ' : ''}${asset.vRazonSocialEmisor || ''}` : '-'}
                                                                        </div>
                                                                    </Col>
                                                                    <Col xs={12} md={6} className="mb-0">
                                                                        <div className="text-uppercase text-muted fw-semibold mb-1" style={{ fontSize: '0.65rem', letterSpacing: '0.5px' }}>Responsable</div>
                                                                        <div className="fw-bold text-dark" style={{ fontSize: '0.85rem' }}>{asset.vGastoResponsable || '-'}</div>
                                                                    </Col>
                                                                </Row>
                                                            </Col>

                                                            <Col xs={12} md={4} className="text-md-end mt-4 mt-md-0 d-flex flex-column justify-content-start">
                                                                <div className="mb-3">
                                                                    <span className="text-muted d-block small mb-1" style={{ fontSize: '0.8rem' }}>Total del Gasto</span>
                                                                    <h4 className="mb-0 fw-bold text-dark">
                                                                        {asset.dGastoTotal != null ? Number(asset.dGastoTotal).toLocaleString("es-MX", { style: "currency", currency: asset.vGastoMoneda || "MXN" }) : "-"}
                                                                    </h4>
                                                                </div>
                                                                {asset.dGastoCantidad && (
                                                                    <div className="text-muted mb-2" style={{ fontSize: '0.85rem' }}>
                                                                        <span className="fw-semibold">Cantidad:</span> {parseFloat(asset.dGastoCantidad).toLocaleString("es-MX")}
                                                                    </div>
                                                                )}
                                                                {asset.dGastoPrecioUnitario && (
                                                                    <div className="text-muted mb-2" style={{ fontSize: '0.85rem' }}>
                                                                        <span className="fw-semibold">P. Unitario:</span> {Number(asset.dGastoPrecioUnitario).toLocaleString("es-MX", { style: "currency", currency: asset.vGastoMoneda || "MXN" })}
                                                                    </div>
                                                                )}
                                                                {asset.dGastoDescuento != null && Number(asset.dGastoDescuento) > 0 && (
                                                                    <div className="text-danger mb-2" style={{ fontSize: '0.85rem' }}>
                                                                        <span className="fw-semibold">Descuento:</span> -{Number(asset.dGastoDescuento).toLocaleString("es-MX", { style: "currency", currency: asset.vGastoMoneda || "MXN" })}
                                                                    </div>
                                                                )}
                                                                {asset.dGastoIva != null && (
                                                                    <div className="text-muted mb-2" style={{ fontSize: '0.85rem' }}>
                                                                        <span className="fw-semibold">IVA (16%):</span> {Number(asset.dGastoIva).toLocaleString("es-MX", { style: "currency", currency: asset.vGastoMoneda || "MXN" })}
                                                                    </div>
                                                                )}
                                                            </Col>

                                                            {/* Factura / Nota Venta */}
                                                            {(asset.vUUIDFactura || asset.bHasNotaVenta === 1) && (
                                                                <Col xs={12} className="pt-3 mt-3 border-top">
                                                                    <div className="d-flex flex-wrap align-items-center gap-4">
                                                                        {asset.vUUIDFactura && asset.idFacturaRecibida > 0 && (
                                                                            <div>
                                                                                <div className="text-uppercase text-muted fw-semibold mb-1" style={{ fontSize: '0.65rem', letterSpacing: '0.5px' }}>Factura Recibida</div>
                                                                                <a
                                                                                    href={`/contabilidad/centro-xml/facturas-recibidas/visualizacion/${asset.idFacturaRecibida}`}
                                                                                    target="_blank"
                                                                                    rel="noopener noreferrer"
                                                                                    className="font-monospace text-primary text-decoration-none fw-bold"
                                                                                    style={{ fontSize: '0.8rem', wordBreak: 'break-all' }}
                                                                                >
                                                                                    <FiFileText className="me-1 text-secondary" />
                                                                                    {asset.vUUIDFactura}
                                                                                </a>
                                                                            </div>
                                                                        )}
                                                                        {asset.bHasNotaVenta === 1 && (
                                                                            <div>
                                                                                <div className="text-uppercase text-muted fw-semibold mb-1" style={{ fontSize: '0.65rem', letterSpacing: '0.5px' }}>Nota de Venta</div>
                                                                                <Button
                                                                                    variant="outline-primary"
                                                                                    size="sm"
                                                                                    onClick={() => handleDescargarNotaVenta(asset.idGasto)}
                                                                                    disabled={descargandoNota}
                                                                                    className="py-1 px-2 d-flex align-items-center"
                                                                                    style={{ fontSize: '0.8rem' }}
                                                                                >
                                                                                    <FiDownload className="me-1" />
                                                                                    {descargandoNota ? 'Descargando...' : 'Ver Nota de Venta'}
                                                                                </Button>
                                                                            </div>
                                                                        )}
                                                                    </div>
                                                                </Col>
                                                            )}
                                                        </Row>
                                                    ) : (
                                                        <div className="alert alert-secondary mb-0 py-2" style={{ fontSize: '0.85rem' }}>
                                                            <FiInfo className="me-2" />
                                                            No hay detalles adicionales disponibles para este gasto.
                                                        </div>
                                                    )}
                                                </Card.Body>
                                            </Card>
                                        </Col>
                                    </Row>
                                ) : null}

                                {/* Fila 3 */}
                                <Row className="g-3">
                                    <Col xs={12}>
                                        <Card className="border-0 shadow-sm rounded-4">
                                            <Card.Body className="p-4">
                                                <Row>
                                                    {/* Columna Izquierda: Información */}
                                                    <Col md={4} className="border-end pe-md-4">
                                                        <div className="d-flex align-items-center mb-4">
                                                            <div className="bg-soft-success rounded-circle d-flex justify-content-center align-items-center me-2" style={{ width: '28px', height: '28px' }}>
                                                                <FiCalendar className="text-success" />
                                                            </div>
                                                            <h6 className="mb-0 fw-bold text-dark">CICLO DE VIDA</h6>
                                                        </div>

                                                        <div className="mb-4">
                                                            <div className="text-uppercase text-muted fw-semibold mb-1" style={{ fontSize: '0.65rem', letterSpacing: '0.5px' }}>FECHA DE ADQUISICIÓN</div>
                                                            <div className="text-dark fw-bold d-flex align-items-center">
                                                                <FiCalendar className="text-primary me-2" style={{ fontSize: '0.9rem' }} />
                                                                {asset.dFechaCompra ? new Date(asset.dFechaCompra).toLocaleDateString('es-MX', { day: '2-digit', month: 'short', year: 'numeric' }) : '-'}
                                                            </div>
                                                        </div>

                                                        <div className="mb-4">
                                                            <div className="text-uppercase text-muted fw-semibold mb-1" style={{ fontSize: '0.65rem', letterSpacing: '0.5px' }}>FECHA DE PUESTA EN USO</div>
                                                            <div className="text-dark fw-bold d-flex align-items-center">
                                                                <FiClock className="text-primary me-2" style={{ fontSize: '0.9rem' }} />
                                                                {asset.dFechaUso ? new Date(asset.dFechaUso).toLocaleDateString('es-MX', { day: '2-digit', month: 'short', year: 'numeric' }) : '-'}
                                                            </div>
                                                        </div>

                                                        <div>
                                                            <div className="text-uppercase text-muted fw-semibold mb-1" style={{ fontSize: '0.65rem', letterSpacing: '0.5px' }}>ANTIGÜEDAD</div>
                                                            <div className="text-dark fw-bold d-flex align-items-center">
                                                                <FiRotateCcw className="text-primary me-2" style={{ fontSize: '0.9rem' }} />
                                                                {calcularTiempoUso(asset.dFechaUso) || '0 meses'} operando
                                                            </div>
                                                        </div>
                                                    </Col>

                                                    {/* Columna Derecha: Gráfica */}
                                                    <Col md={8} className="ps-md-4">
                                                        {(() => {
                                                            const chartData = [];
                                                            if (asset.dCostoAdquisicion && asset.dFechaUso && asset.dDepreciacionAnual) {
                                                                const maxYears = Math.ceil(100 / asset.dDepreciacionAnual);
                                                                const startYear = new Date(asset.dFechaUso).getFullYear();
                                                                const costoStr = asset.dCostoAdquisicion.toString().replace(/,/g, '');
                                                                let currentCosto = parseFloat(costoStr);
                                                                if(isNaN(currentCosto)) currentCosto = 0;
                                                                let anualDepValue = currentCosto * (asset.dDepreciacionAnual / 100);
                                                                
                                                                for (let i = 0; i <= maxYears; i++) {
                                                                    let devaluado = anualDepValue * i;
                                                                    let valorRestante = currentCosto - devaluado;
                                                                    if (valorRestante < 0) valorRestante = 0;
                                                                    if (devaluado > currentCosto) devaluado = currentCosto;
                                                                    
                                                                    chartData.push({
                                                                        year: (startYear + i).toString(),
                                                                        valor: valorRestante,
                                                                        depreciacion: devaluado
                                                                    });
                                                                }
                                                            }

                                                            if (chartData.length === 0) {
                                                                return (
                                                                    <div className="d-flex justify-content-center align-items-center h-100 text-muted" style={{ minHeight: '200px' }}>
                                                                        <div className="text-center">
                                                                            <FiInfo className="mb-2 fs-3" />
                                                                            <p className="mb-0" style={{ fontSize: '0.85rem' }}>Información insuficiente para proyectar depreciación.</p>
                                                                        </div>
                                                                    </div>
                                                                );
                                                            }

                                                            return (
                                                                <div className="w-100">
                                                                    <div className="text-center mb-3">
                                                                        <h6 className="text-muted mb-0" style={{ fontSize: '0.95rem', fontWeight: '600' }}>
                                                                            Proyección de Depreciación (A lo largo de su vida útil)
                                                                        </h6>
                                                                    </div>
                                                                    <div style={{ width: '100%', height: 250 }}>
                                                                        <ResponsiveContainer>
                                                                            <BarChart
                                                                                data={chartData}
                                                                                margin={{ top: 10, right: 10, left: 0, bottom: 0 }}
                                                                            >
                                                                                <defs>
                                                                                    <linearGradient id="colorValor" x1="0" y1="0" x2="0" y2="1">
                                                                                        <stop offset="5%" stopColor="#8b5cf6" stopOpacity={1}/>
                                                                                        <stop offset="95%" stopColor="#8b5cf6" stopOpacity={0.2}/>
                                                                                    </linearGradient>
                                                                                    <linearGradient id="colorDep" x1="0" y1="0" x2="0" y2="1">
                                                                                        <stop offset="5%" stopColor="#14b8a6" stopOpacity={1}/>
                                                                                        <stop offset="95%" stopColor="#14b8a6" stopOpacity={0.2}/>
                                                                                    </linearGradient>
                                                                                </defs>
                                                                                <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#f0f0f0" />
                                                                                <XAxis dataKey="year" axisLine={false} tickLine={false} tick={{ fontSize: 11, fill: '#6c757d' }} />
                                                                                <YAxis 
                                                                                    axisLine={false} 
                                                                                    tickLine={false} 
                                                                                    tick={{ fontSize: 11, fill: '#6c757d' }}
                                                                                    tickFormatter={(value) => `$${value >= 1000 ? (value / 1000) + 'k' : value}`}
                                                                                    width={50}
                                                                                />
                                                                                <Tooltip 
                                                                                    formatter={(value, name) => [`$${parseFloat(value).toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2})}`, name]}
                                                                                    labelStyle={{ color: '#212529', fontWeight: 'bold' }}
                                                                                    contentStyle={{ borderRadius: '8px', border: 'none', boxShadow: '0 4px 6px rgba(0,0,0,0.1)' }}
                                                                                    cursor={{ fill: '#f8f9fa' }}
                                                                                />
                                                                                <Legend wrapperStyle={{ fontSize: '12px' }} />
                                                                                <Bar dataKey="valor" name="Valor Actual" fill="url(#colorValor)" radius={[4, 4, 0, 0]} maxBarSize={40} />
                                                                                <Bar dataKey="depreciacion" name="Depreciación Acumulada" fill="url(#colorDep)" radius={[4, 4, 0, 0]} maxBarSize={40} />
                                                                            </BarChart>
                                                                        </ResponsiveContainer>
                                                                    </div>
                                                                </div>
                                                            );
                                                        })()}
                                                    </Col>
                                                </Row>
                                            </Card.Body>
                                        </Card>
                                    </Col>
                                </Row>
                            </div>
                        ) : (
                            <Form onSubmit={handleSubmit}>
                                <Card className="shadow-sm">
                                    <Card.Body>
                                        {editando && (!asset.idGasto || asset.idGasto === 0) && (
                                            <div className="d-flex justify-content-end mb-3">
                                                <Button
                                                    variant="outline-primary"
                                                    size="sm"
                                                    onClick={() => {
                                                        setSearchTermGasto('');
                                                        setGastosEncontrados([]);
                                                        setMostrarModalGasto(true);
                                                    }}
                                                >
                                                    <FiLink className="me-1" /> Vincular Gasto Existente
                                                </Button>
                                            </div>
                                        )}

                                        {/* Primera fila */}
                                        <Row className="gy-3">
                                            <Col xs={6} sm={6} md={3}>
                                                <Form.Group>
                                                    <Form.Label className="fw-semibold">Nombre del Activo</Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        autoComplete="off"
                                                        onKeyUp={event => { event.target.value = event.target.value.toUpperCase() }}
                                                        placeholder="Ingresa el nombre del activo"
                                                        name="vNombreActivo"
                                                        value={asset.vNombreActivo ?? ""}
                                                        onChange={handleChange}
                                                        disabled={!editando || (asset.idGasto && asset.idGasto !== 0)}
                                                    />
                                                    {errores.vNombreActivo && <div className="text-danger">{errores.vNombreActivo}</div>}
                                                </Form.Group>
                                            </Col>
                                            <Col xs={6} sm={6} md={3}>
                                                <Form.Group>
                                                    <Form.Label className="fw-semibold">N&uacute;mero de serie</Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        autoComplete="off"
                                                        onKeyUp={event => { event.target.value = event.target.value.toUpperCase() }}
                                                        placeholder="Ingresa el n&uacute;mero de serie"
                                                        name="vNumeroSerie"
                                                        value={asset.vNumeroSerie ?? ""}
                                                        onChange={handleChange}
                                                        disabled={!editando}
                                                    />

                                                    {errores.vNumeroSerie && <div className="text-danger">{errores.vNumeroSerie}</div>}
                                                </Form.Group>
                                            </Col>


                                            <Col xs={6} sm={6} md={3}>
                                                <Form.Group>
                                                    <Form.Label className="fw-semibold">
                                                        <span className="d-none d-xl-inline-block ms-1">N&uacute;mero de registro</span>
                                                        <span className="d-xl-none ms-1 " >N&uacute;mero de regis...</span>
                                                    </Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        autoComplete="off"
                                                        onKeyUp={event => { event.target.value = event.target.value.toUpperCase() }}
                                                        placeholder="Ingresa el n&uacute;mero del registro"
                                                        name="vNumeroRegistro"
                                                        value={asset.vNumeroRegistro ?? ""}
                                                        onChange={handleChange}
                                                        disabled={!editando}
                                                    />
                                                    {errores.vNumeroRegistro && <div className="text-danger">{errores.vNumeroRegistro}</div>}
                                                </Form.Group>
                                            </Col>
                                            <Col xs={6} sm={6} md={3}>
                                                <Form.Group>
                                                    <Form.Label className="fw-semibold">Valor</Form.Label>
                                                    <Form.Control
                                                        type="number"
                                                        autoComplete="off"
                                                        placeholder="Ingresa el valor del activo"
                                                        name="dCostoAdquisicion"
                                                        value={asset.dCostoAdquisicion ?? ""}
                                                        onChange={handleChange}
                                                        disabled={!editando || (asset.idGasto && asset.idGasto !== 0)}
                                                        min={0}
                                                        onKeyDown={e => {
                                                            if (e.key === '-' || e.key === 'e') {
                                                                e.preventDefault();
                                                            }
                                                        }}
                                                    />
                                                    {errores.dCostoAdquisicion && <div className="text-danger">{errores.dCostoAdquisicion}</div>}
                                                </Form.Group>
                                            </Col>
                                        </Row>
                                        {/* Segunda fila */}
                                        <Row className="gy-3 mt-2">
                                            <Col xs={6} md={6} sm={12}>
                                                <Form.Group>
                                                    <Form.Label className="fw-semibold">Descripci&oacute;n</Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        autoComplete="off"
                                                        onKeyUp={event => { event.target.value = event.target.value.toUpperCase() }}
                                                        placeholder="Ingresa una descripci&oacute;n"
                                                        name="vDescripcion"
                                                        value={asset.vDescripcion ?? ""}
                                                        onChange={handleChange}
                                                        disabled={!editando}
                                                    />
                                                    {errores.vDescripcion && <div className="text-danger">{errores.vDescripcion}</div>}
                                                </Form.Group>
                                            </Col>

                                            <Col xs={6} md={6} sm={12}>
                                                <Row>
                                                    <Col xs={6} md={6} sm={6}>
                                                        <Form.Group>
                                                            <Form.Label className="fw-semibold">Categor&iacute;a</Form.Label>
                                                            <Form.Control
                                                                as="select"
                                                                name="idCategoria"
                                                                value={asset.idCategoria ?? 0}
                                                                onChange={handleChange}
                                                                disabled={!editando}
                                                            >
                                                                <option value="">Selecciona una categor&iacute;a</option>
                                                                <option value="1">Electr&oacute;nica</option>
                                                                <option value="2">Mobiliario</option>
                                                                <option value="3">Veh&iacute;culos</option>
                                                                <option value="4">Inmuebles</option>
                                                                <option value="5">Otros</option>
                                                            </Form.Control>
                                                            {errores.idCategoria && <div className="text-danger">{errores.idCategoria}</div>}
                                                        </Form.Group>
                                                    </Col>
                                                    <Col xs={6} md={6} sm={6}>
                                                        <Form.Group>
                                                            <Form.Label className="fw-semibold">Estado</Form.Label>
                                                            <Form.Control
                                                                as="select"
                                                                name="iEstadoActivo"
                                                                value={asset.iEstadoActivo ?? null}
                                                                onChange={handleChange}
                                                                disabled={!editando}
                                                            >
                                                                <option value="">Selecciona el estado</option>
                                                                <option value="0">0 - Inservible</option>
                                                                <option value="1">1 - Activo</option>
                                                                <option value="2">2 - En Reparaci&oacute;n</option>
                                                            </Form.Control>
                                                            {errores.iEstadoActivo && <div className="text-danger">{errores.iEstadoActivo}</div>}
                                                        </Form.Group>
                                                    </Col>
                                                </Row>
                                            </Col>
                                        </Row>
                                        {/* Tercera fila */}
                                        <Row className="gy-3 mt-2">
                                            <Col xs={6} sm={6} md={3} xl={3}>
                                                <Form.Group>
                                                    <Form.Label className="fw-semibold">Responsable</Form.Label>
                                                    <Form.Control
                                                        as="select"
                                                        name="idEmpleadoResponsable"
                                                        value={asset.idEmpleadoResponsable ?? 0}
                                                        onChange={handleChange}
                                                        disabled={!editando}
                                                    >
                                                        <option value="">Todos los empleados</option>
                                                        {empleados.map((empleado, index) => (
                                                            <option key={index} value={empleado.idUsuario}>
                                                                {empleado.vNombre} {empleado.vApellidos}
                                                            </option>
                                                        ))}
                                                    </Form.Control>
                                                    {errores.idEmpleadoResponsable && <div className="text-danger">{errores.idEmpleadoResponsable}</div>}
                                                </Form.Group>
                                            </Col>
                                            <Col xs={6} sm={6} md={3} xl={3}>
                                                <Form.Group>
                                                    <Form.Label className="fw-semibold">Ubicaci&oacute;n</Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        autoComplete="off"
                                                        onKeyUp={event => { event.target.value = event.target.value.toUpperCase() }}
                                                        placeholder="Ingresa la ubicaci&oacute;n"
                                                        name="vUbicacionActivo"
                                                        value={asset.vUbicacionActivo ?? ""}
                                                        onChange={handleChange}
                                                        disabled={!editando}
                                                    />
                                                    {errores.vUbicacionActivo && <div className="text-danger">{errores.vUbicacionActivo}</div>}
                                                </Form.Group>
                                            </Col>
                                            <Col xs={6} sm={6} md={3} xl={3}>
                                                <Form.Group>
                                                    <Form.Label className="fw-semibold">Fecha de Compra</Form.Label>
                                                    <DatePicker
                                                        selected={asset.dFechaCompra ? new Date(asset.dFechaCompra) : null}
                                                        dateFormat="dd MMM yyyy"
                                                        onChange={(newDate) =>
                                                            setAsset((prev) => ({ ...prev, dFechaCompra: newDate ? new Date(newDate) : null }))
                                                        }
                                                        className="form-control"
                                                        wrapperClassName="w-100"
                                                        placeholderText="Selecciona la fecha de compra"
                                                        disabled={!editando || (asset.idGasto && asset.idGasto !== 0)}
                                                    />
                                                    {errores.dFechaCompra && (
                                                        <div className="text-danger">{errores.dFechaCompra}</div>
                                                    )}
                                                </Form.Group>
                                            </Col>

                                            <Col xs={6} sm={6} md={3} xl={3}>
                                                <Form.Group>
                                                    <Form.Label className="fw-semibold">Fecha de Uso</Form.Label>
                                                    <br />
                                                    <DatePicker
                                                        selected={asset.dFechaUso ? new Date(asset.dFechaUso) : null}
                                                        dateFormat="dd MMM yyyy"
                                                        onChange={newDate => setAsset(prev => ({ ...prev, dFechaUso: newDate ? new Date(newDate) : null }))}
                                                        wrapperClassName="w-100"
                                                        placeholderText="Selecciona la fecha de uso"
                                                        className="form-control"

                                                        disabled={!editando}
                                                    />
                                                    {errores.dFechaUso && <div className="text-danger">{errores.dFechaUso}</div>}
                                                </Form.Group>
                                            </Col>

                                            <Col xs={6} sm={6} md={3} xl={3}>
                                                <Form.Group>
                                                    <Form.Label className="fw-semibold">Depreciaci&oacute;n Anual</Form.Label>
                                                    <Form.Control
                                                        type="number"
                                                        step="0.001"
                                                        value={asset.dDepreciacionAnual ?? ''}
                                                        onChange={e => setAsset(prev => ({ ...prev, dDepreciacionAnual: e.target.value }))}
                                                        placeholder="Ingresa la depreciaci&oacute;n anual"
                                                        name="dDepreciacionAnual"
                                                        disabled={!editando}
                                                    />
                                                    {errores.dDepreciacionAnual && <div className="text-danger">{errores.dDepreciacionAnual}</div>}
                                                </Form.Group>
                                            </Col>
                                        </Row>

                                        {/* Tarjeta de Gasto Vinculado */}
                                        {asset.idGasto && asset.idGasto !== 0 && (
                                            <Row className="mt-4">
                                                <Col md={12}>
                                                    <div className="border rounded p-3 bg-light shadow-sm">
                                                        <div className="d-flex justify-content-between align-items-center mb-3">
                                                            <h6 className="mb-0 text-primary fw-bold">
                                                                <FiLink className="me-1" /> Gasto Vinculado #{asset.idGasto}
                                                            </h6>
                                                            {editando && (
                                                                <Button
                                                                    variant="outline-danger"
                                                                    size="sm"
                                                                    onClick={handleDesvincularGasto}
                                                                    title="Desvincular Gasto"
                                                                >
                                                                    <FiTrash2 className="me-1" /> Desvincular Gasto
                                                                </Button>
                                                            )}
                                                        </div>

                                                        <Row className="g-3">
                                                            <Col md={8}>
                                                                <div className="mb-2">
                                                                    <strong>Concepto:</strong> {asset.vGastoDescripcion || asset.vNombreActivo}
                                                                </div>
                                                                <div className="text-muted small mb-1">
                                                                    <strong>Categoría:</strong> {asset.vGastoTipoGasto || 'No especificada'}
                                                                </div>
                                                                <div className="text-muted small mb-1">
                                                                    <strong>Forma de Pago:</strong> {asset.vGastoFormaPago || 'No especificada'}
                                                                </div>
                                                                {asset.dFechaGasto && (
                                                                    <div className="text-muted small mb-1">
                                                                        <strong>Fecha del Gasto:</strong> {new Date(asset.dFechaGasto).toLocaleDateString("es-MX", { day: '2-digit', month: 'short', year: 'numeric' })}
                                                                    </div>
                                                                )}
                                                                {asset.DetallesCuenta && (
                                                                    <div className="text-muted small mb-1">
                                                                        <strong>Cuenta:</strong> <Badge bg="light" text="dark" className="border">{asset.DetallesCuenta}</Badge>
                                                                    </div>
                                                                )}
                                                                {asset.vGastoResponsable && (
                                                                    <div className="text-muted small mb-1">
                                                                        <strong>Responsable:</strong> {asset.vGastoResponsable}
                                                                    </div>
                                                                )}
                                                                {(asset.vRfcEmisor || asset.vRazonSocialEmisor) && (
                                                                    <div className="text-muted small mb-1">
                                                                        <strong>Emisor:</strong> {asset.vRfcEmisor}{asset.vRfcEmisor && asset.vRazonSocialEmisor && ' - '}{asset.vRazonSocialEmisor}
                                                                    </div>
                                                                )}
                                                                {asset.vUUIDFactura && asset.idFacturaRecibida > 0 && (
                                                                    <div className="mt-2 small">
                                                                        <strong>
                                                                            <FiFileText className="me-1 text-secondary" /> Factura:
                                                                        </strong>
                                                                        <a
                                                                            href={`/contabilidad/centro-xml/facturas-recibidas/visualizacion/${asset.idFacturaRecibida}`}
                                                                            target="_blank"
                                                                            rel="noopener noreferrer"
                                                                            className="ms-1 font-monospace text-primary text-decoration-none"
                                                                            style={{ wordBreak: 'break-all' }}
                                                                        >
                                                                            {asset.vUUIDFactura}
                                                                        </a>
                                                                    </div>
                                                                )}
                                                                {asset.bHasNotaVenta === 1 && (
                                                                    <div className="mt-3">
                                                                        <Button
                                                                            variant="outline-primary"
                                                                            size="sm"
                                                                            onClick={() => handleDescargarNotaVenta(asset.idGasto)}
                                                                            disabled={descargandoNota}
                                                                        >
                                                                            <FiDownload className="me-1" />
                                                                            {descargandoNota ? 'Descargando...' : 'Ver Nota de Venta'}
                                                                        </Button>
                                                                    </div>
                                                                )}
                                                            </Col>
                                                            <Col md={4} className="text-md-end border-start-md">
                                                                <div className="mb-2">
                                                                    <span className="text-muted d-block small">Total del Gasto</span>
                                                                    <h4 className="mb-0 fw-bold text-dark">
                                                                        {asset.dGastoTotal != null ? Number(asset.dGastoTotal).toLocaleString("es-MX", {
                                                                            style: "currency",
                                                                            currency: asset.vGastoMoneda || "MXN"
                                                                        }) : "$0.00"}
                                                                    </h4>
                                                                </div>
                                                                {asset.dGastoCantidad && (
                                                                    <div className="text-muted small mb-1">
                                                                        <strong>Cantidad:</strong> {parseFloat(asset.dGastoCantidad).toLocaleString("es-MX")}
                                                                    </div>
                                                                )}
                                                                {asset.dGastoPrecioUnitario && (
                                                                    <div className="text-muted small mb-1">
                                                                        <strong>P. Unitario:</strong> {Number(asset.dGastoPrecioUnitario).toLocaleString("es-MX", { style: "currency", currency: asset.vGastoMoneda || "MXN" })}
                                                                    </div>
                                                                )}
                                                                {asset.dGastoDescuento != null && Number(asset.dGastoDescuento) > 0 && (
                                                                    <div className="text-danger small mb-1">
                                                                        <strong>Descuento:</strong> -{Number(asset.dGastoDescuento).toLocaleString("es-MX", { style: "currency", currency: asset.vGastoMoneda || "MXN" })}
                                                                    </div>
                                                                )}
                                                                {asset.dGastoIva != null && (
                                                                    <div className="text-muted small mb-1">
                                                                        <strong>IVA:</strong> {Number(asset.dGastoIva).toLocaleString("es-MX", { style: "currency", currency: asset.vGastoMoneda || "MXN" })}
                                                                    </div>
                                                                )}
                                                            </Col>
                                                        </Row>
                                                    </div>
                                                </Col>
                                            </Row>
                                        )}
                                    </Card.Body>
                                </Card>
                            </Form>
                        )}

                        {/* Modal para Buscar Gasto */}
                        <Modal show={mostrarModalGasto} onHide={() => setMostrarModalGasto(false)} size="lg" centered>
                            <Modal.Header closeButton>
                                <Modal.Title>
                                    <FiLink className="me-2 text-primary" /> Vincular Gasto Existente
                                </Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                                <Form.Group className="mb-4">
                                    <Form.Label className="fw-semibold">Buscar gasto por descripción o UUID de factura</Form.Label>
                                    <div className="position-relative">
                                        <Form.Control
                                            type="text"
                                            placeholder="Escribe la descripción o folio fiscal (UUID)..."
                                            value={searchTermGasto}
                                            onChange={(e) => setSearchTermGasto(e.target.value)}
                                            style={{ paddingLeft: '2.5rem' }}
                                        />
                                        <FiSearch className="position-absolute text-muted" style={{ left: '1rem', top: '50%', transform: 'translateY(-50%)' }} />
                                    </div>
                                    <Form.Text className="text-muted">
                                        Los resultados se filtran automáticamente a medida que escribes (mínimo 3 caracteres).
                                    </Form.Text>
                                </Form.Group>

                                <div className="border rounded bg-light p-3" style={{ maxHeight: '400px', overflowY: 'auto' }}>
                                    {buscandoGastos ? (
                                        <div className="text-center py-4">
                                            <div className="spinner-border spinner-border-sm text-primary me-2" role="status" />
                                            <span>Buscando gastos coincidentes...</span>
                                        </div>
                                    ) : gastosEncontrados.length > 0 ? (
                                        gastosEncontrados.map((gasto) => {
                                            const totalFormateado = Number(gasto.dGastoTotal).toLocaleString("es-MX", {
                                                style: "currency",
                                                currency: gasto.vGastoMoneda || "MXN"
                                            });
                                            const fechaFormateada = new Date(gasto.dFechaGasto).toLocaleDateString("es-MX", {
                                                day: "2-digit",
                                                month: "short",
                                                year: "numeric"
                                            });

                                            return (
                                                <div key={gasto.idGasto} className="card border border-light shadow-none mb-2 hover-shadow p-3 rounded" style={{ transition: 'all 0.2s', cursor: 'pointer', backgroundColor: '#fff' }} onClick={() => handleSeleccionarGasto(gasto)}>
                                                    <div className="d-flex justify-content-between align-items-start flex-wrap gap-2">
                                                        <div style={{ flex: '1 1 60%' }}>
                                                            <div className="d-flex align-items-center gap-2 mb-1">
                                                                <span className="badge bg-primary bg-opacity-10 text-primary">#{gasto.idGasto}</span>
                                                                <small className="text-muted">{fechaFormateada}</small>
                                                            </div>
                                                            <h6 className="mb-1 text-dark fw-bold">{gasto.vGastoDescripcion}</h6>
                                                            <div className="text-muted small">
                                                                <strong>Tipo:</strong> {gasto.vGastoTipoGasto} | <strong>Forma de pago:</strong> {gasto.vGastoFormaPago}
                                                            </div>
                                                            {gasto.vUUIDFactura && (
                                                                <div className="text-muted small font-monospace mt-1">
                                                                    UUID: {gasto.vUUIDFactura}
                                                                </div>
                                                            )}
                                                        </div>
                                                        <div className="text-md-end" style={{ flex: '1 1 30%', minWidth: '150px' }}>
                                                            <div className="fw-bold fs-5 text-dark mb-2">{totalFormateado}</div>
                                                            <Button
                                                                variant="primary"
                                                                size="sm"
                                                                onClick={(e) => {
                                                                    e.stopPropagation();
                                                                    handleSeleccionarGasto(gasto);
                                                                }}
                                                            >
                                                                <FiLink className="me-1" /> Seleccionar
                                                            </Button>
                                                        </div>
                                                    </div>
                                                </div>
                                            );
                                        })
                                    ) : (
                                        <div className="text-center py-4 text-muted">
                                            {searchTermGasto.trim().length >= 3 ? "No se encontraron gastos con ese criterio." : "Escribe al menos 3 caracteres para iniciar la búsqueda."}
                                        </div>
                                    )}
                                </div>
                            </Modal.Body>
                            <Modal.Footer>
                                <Button variant="secondary" onClick={() => setMostrarModalGasto(false)}>
                                    Cerrar
                                </Button>
                            </Modal.Footer>
                        </Modal>
                    </>
                )}






            {id && <Card className="mt-3">
                <Card.Body>
                    <Row>
                        <Col md={12}>
                            <h5 className=" mb-4">
                                <FiRotateCcw className="me-2" style={{ verticalAlign: 'middle' }} />
                                Historial de Asignaci&oacute;n
                            </h5>
                            {cargando ? (
                                <Skeleton count={3} />
                            ) : (
                                <div className="timeline-container">
                                    {historialAsignaciones.length > 0 || (asset && (asset.vNombreResponsable || asset.vApellidosResponsable)) ? (
                                        <div className="position-relative">
                                            {/* Línea vertical principal */}
                                            <div
                                                className="position-absolute bg-light"
                                                style={{
                                                    left: '15px',
                                                    top: '0',
                                                    bottom: '0',
                                                    width: '2px'
                                                }}
                                            ></div>

                                            {/* Empleado Actual */}
                                            {asset && (asset.vNombreResponsable || asset.vApellidosResponsable) && (
                                                <div className="d-flex align-items-center mb-3 position-relative">
                                                    {/* Indicador de timeline - Verde para actual */}
                                                    <div
                                                        className={`d-flex align-items-center justify-content-center position-relative`}
                                                        style={{
                                                            width: '30px',
                                                            height: '30px',
                                                            minWidth: '30px',
                                                            zIndex: 1
                                                        }}
                                                    >
                                                        <div
                                                            className="rounded-circle bg-success d-flex align-items-center justify-content-center"
                                                            style={{
                                                                width: '20px',
                                                                height: '20px'
                                                            }}
                                                        >
                                                            <FiUserCheck className="text-white" style={{ fontSize: '10px' }} />
                                                        </div>
                                                    </div>

                                                    {/* Contenido del actual */}
                                                    <div className="flex-grow-1">
                                                        <div className="card border-0 bg-success bg-opacity-10" style={{ fontSize: '0.9rem' }}>
                                                            <div className="card-body p-3">
                                                                <div className="d-flex justify-content-between align-items-start">
                                                                    <div className="flex-grow-1">
                                                                        {/* Nombre del empleado actual */}
                                                                        <div className="d-flex align-items-center mb-2">
                                                                            <h6 className="mb-0 text-success fw-bold me-2">
                                                                                <FiUser className="me-2" />
                                                                                {asset.vNombreResponsable && asset.vApellidosResponsable
                                                                                    ? `${asset.vNombreResponsable} ${asset.vApellidosResponsable}`
                                                                                    : asset.vNombreResponsable || asset.vApellidosResponsable || 'Sin responsable'
                                                                                }
                                                                            </h6>
                                                                            <span className="badge bg-success text-white">
                                                                                <FiUserCheck className="me-1" style={{ fontSize: '10px' }} />
                                                                                ACTUAL
                                                                            </span>
                                                                        </div>



                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            )}

                                            {/* Historial de Asignaciones */}
                                            {historialAsignaciones.map((asignacion, index) => {
                                                const empleadoActual = asignacion.idEmpleadoResponsable === 0
                                                    ? "Todos los empleados"
                                                    : asignacion.vNombreResponsable
                                                        ? `${asignacion.vNombreResponsable} ${asignacion.vApellidosResponsable}`
                                                        : "Sin responsable";



                                                const hayTransicion = asignacion.idEmpleadoResponsableAnterior !== undefined &&
                                                    asignacion.idEmpleadoResponsableAnterior !== null;

                                                return (
                                                    <div key={index} className="d-flex align-items-center mb-3 position-relative">
                                                        {/* Indicador de timeline */}
                                                        <div
                                                            className={`d-flex align-items-center justify-content-center position-relative`}
                                                            style={{
                                                                width: '30px',
                                                                height: '30px',
                                                                minWidth: '30px',
                                                                zIndex: 1
                                                            }}
                                                            title={empleadoActual}
                                                        >
                                                            <div
                                                                className="rounded-circle bg-primary d-flex align-items-center justify-content-center"
                                                                style={{
                                                                    width: '20px',
                                                                    height: '20px'
                                                                }}
                                                            >
                                                                <i className="fas fa-history text-white" style={{ fontSize: '10px' }}></i>
                                                            </div>
                                                        </div>

                                                        {/* Contenido */}
                                                        <div className="flex-grow-1">
                                                            <div className="card border-0 bg-light" style={{ fontSize: '0.9rem' }}>
                                                                <div className="card-body p-3">
                                                                    <div className="d-flex justify-content-between align-items-start">
                                                                        <div className="flex-grow-1">
                                                                            {/* Nombre del empleado con transición */}
                                                                            <div className="d-flex align-items-center mb-2">
                                                                                {/* Empleado anterior (solo imagen) */}
                                                                                {hayTransicion && asignacion.idEmpleadoResponsableAnterior && asignacion.idEmpleadoResponsableAnterior !== 0 && (
                                                                                    <>
                                                                                        <div className="me-2" style={{ width: '32px', height: '32px' }}
                                                                                            title={asignacion.vNombreResponsableAnterior + ' ' + asignacion.vApellidosResponsableAnterior}
                                                                                        >

                                                                                            <ImagenPerfil idUsuario={asignacion.idEmpleadoResponsableAnterior} placeholder={asignacion.vNombreResponsableAnterior + " " + asignacion.vApellidosResponsableAnterior} />
                                                                                        </div>

                                                                                        {/* Flecha */}
                                                                                        <FiArrowRight className="me-2 text-gray" style={{ fontSize: '16px' }} />
                                                                                    </>
                                                                                )}

                                                                                {/* Empleado actual */}
                                                                                {asignacion.idEmpleadoResponsable && asignacion.idEmpleadoResponsable !== 0 && (
                                                                                    <div className="me-2" style={{ width: '32px', height: '32px' }}
                                                                                        title={asignacion.vNombreResponsable + ' ' + asignacion.vApellidosResponsable}
                                                                                    >
                                                                                        <ImagenPerfil idUsuario={asignacion.idEmpleadoResponsable} placeholder={asignacion.vNombreResponsable + " " + asignacion.vApellidosResponsable} />
                                                                                    </div>
                                                                                )}
                                                                                <h6 className="mb-0 text-dark fw-bold">
                                                                                    {empleadoActual}
                                                                                </h6>
                                                                            </div>

                                                                            {/* Línea separadora */}
                                                                            <hr className="my-2" style={{ opacity: 0.6, borderWidth: '1px' }} />

                                                                            {/* Información adicional */}
                                                                            <div className="d-flex flex-wrap gap-3 small text-muted">
                                                                                {asignacion.vCreatedUser && (
                                                                                    <div className="d-flex align-items-center">
                                                                                        <FiUserCheck className="me-1" />
                                                                                        <span>{asignacion.vCreatedUser}</span>
                                                                                    </div>
                                                                                )}
                                                                                {asignacion.dFechaCambio && (
                                                                                    <div className="d-flex align-items-center">
                                                                                        <FiCalendar className="me-1" />
                                                                                        <span>
                                                                                            {new Date(asignacion.dFechaCambio).toLocaleDateString('es-ES', {
                                                                                                day: 'numeric',
                                                                                                month: 'long',
                                                                                                year: 'numeric'
                                                                                            })}
                                                                                        </span>
                                                                                    </div>
                                                                                )}
                                                                                {asignacion.dFechaCambio && (
                                                                                    <div className="d-flex align-items-center">
                                                                                        <FiClock className="me-1" />
                                                                                        <span>
                                                                                            {new Date(asignacion.dFechaCambio).toLocaleTimeString('es-ES', {
                                                                                                hour: '2-digit',
                                                                                                minute: '2-digit'
                                                                                            })}
                                                                                        </span>
                                                                                    </div>
                                                                                )}

                                                                                {asignacion.vIp && (
                                                                                    <div className="d-flex align-items-center">
                                                                                        <FiWifi className="me-1" />
                                                                                        <span>{asignacion.vIp}</span>
                                                                                    </div>
                                                                                )}
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                );
                                            })}                                        </div>
                                    ) : (
                                        <div className="text-center py-4">
                                            <i className="fas fa-history fa-2x text-muted mb-2"></i>
                                            <h6 className="text-muted">No hay historial disponible</h6>
                                            <small className="text-muted">Los cambios aparecer&aacute;n aqu&iacute;</small>
                                        </div>
                                    )}
                                </div>
                            )}
                        </Col>
                    </Row>
                </Card.Body>
            </Card>
            }

            {/* Modal para ver detalles completos del gasto vinculado */}
            <ModalVisualizarDetallesGasto
                show={showVistaGasto}
                selectedGasto={asset}
                onClose={() => setShowVistaGasto(false)}
            />
        </>
    );
};

export default AssetForm


